<template>
    <div>
        <h1 class="text-center">Add User</h1>
        <section class="User">
            <div class="row">

                <form class="ui form addUserForm"  @submit.prevent="$_admin_user_add_checkAddUser">
                    <div class="col-md-12">

                        <div class="box box-info">
                            <!-- Input Addons -->
                            <div class="box-header with-border">
                                <h3 class="box-title">Inputs</h3>
                            </div>

                            <div class="box-body">

                                <div class="row">
                                    <div
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.email.$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].email}}:</label>
                                        <label v-if="!$v.email.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="email"
                                                class="form-control"
                                                placeholder="email"
                                                type="text"
                                                ref="addUserEmail">
                                        </div>
                                    </div>

                                    <div 
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.phone.$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].phone}}:</label>
                                        <label v-if="!$v.phone.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="phone"
                                                class="form-control"
                                                placeholder="phone"
                                                type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div 
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.password.$invalid }"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].password}}:</label>
                                        <label v-if="!$v.password.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <label v-if="!$v.password.minLength">{{$i18n.messages[$i18n.locale].minLength}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="password"
                                                class="form-control"
                                                placeholder="password"
                                                type="password">
                                        </div>
                                    </div>

                                    <div 
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.confirmPassword.$invalid }"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].confirmPassword}}:</label>
                                        <label v-if="!$v.confirmPassword.sameAsPassword">{{$i18n.messages[$i18n.locale].sameAsPassword}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="confirmPassword"
                                                class="form-control"
                                                placeholder="confirmPassword"
                                                type="password">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>{{$i18n.messages[$i18n.locale].type}}:</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                              <i
                                                  class="fa fa-fw fa-edit"
                                                  aria-hidden="true">
                                              </i>
                                            </span>
                                            <select
                                                id="type"
                                                v-model="type"
                                                class="form-control"
                                            >
                                                <option value="private">private</option>
                                                <option value="company">company</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div
                                    class="col-md-6"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].companyName}}:</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="companyName"
                                                class="form-control"
                                                placeholder="companyName"
                                                type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>{{$i18n.messages[$i18n.locale].status}}:</label>
                                            <select
                                                v-model="status"
                                                class="form-control">
                                                <option value="unconfirmed">unconfirmed</option>
                                                <option value="confirmed">confirmed</option>
                                                <option value="archived">archived</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <label>{{$i18n.messages[$i18n.locale].wantMessage}}:</label>
                                        <input
                                            v-model="wantMessage"
                                            type="checkbox"
                                        />
                                    </div>
                                </div>

                                <!-- /input-group -->
                            </div>

                            <!-- /.box-body -->
                            <div v-bind:class="{overlay: true, hidden: !loading}">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                        </div>

                        <div class="box">
                            <br />
                            <div class="row">
                                <div class="col-md-5">
                                </div>
                                <div class="col-md-2">
                                    <button
                                        type="button"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        :title="$t('clear')"
                                        :class="'btn btn-warning btn-lg ' + loading"
                                        @click="$_admin_user_add_clearInput()">
                                        {{$i18n.messages[$i18n.locale].clear}}
                                    </button>
                                    <button
                                        type="submit"
                                        :disabled="$v.$invalid"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        :title="$t('submit')"
                                        :class="'btn btn-primary btn-lg ' + loading">
                                        {{$i18n.messages[$i18n.locale].submit}}
                                    </button>
                                </div>
                                <div class="col-md-5">
                                </div>
                            </div>
                            <br />
                            <div v-bind:class="{overlay: true, hidden: !loading}">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                        </div>

                        <div
                            class="alert alert-success alert-dismissible"
                            v-bind:class="{hidden: !insertSuccess}">
                            <button
                                type="button"
                                class="close"
                                data-dismiss="alert"
                                aria-hidden="true"
                                @click="$_admin_user_add_closeAndRedirect()">
                                &times;
                            </button>
                            <h4><i class="icon fa fa-check"></i> {{$i18n.messages[$i18n.locale].success}}!</h4>
                        </div>

                    </div>
                </form>

            </div>
        </section>
    </div>
</template>
<script>
    import api from '../../api'
    import config from '../../config'
    import { required, sameAs, minLength } from 'vuelidate/lib/validators'

    export default {
        name: 'AddUser',
        components: {

        },
        validations () {
            let data = {
                password: {
                    required,
                    minLength: minLength(6)
                },
                confirmPassword: {
                    sameAsPassword: sameAs('password')
                },
                phone: {
                    required
                },
                email: {
                    required
                }
            }
            return data
        },
        data (router) {
            return {
                section: 'AddUser',
                loading: false,
                insertSuccess: false,
                email: '',
                password: '',
                confirmPassword: '',
                phone: '',
                type: 'private',
                companyName: '',
                status: 'unconfirmed',
                wantMessage: false
            }
        },
        mounted () {
            this.$refs.addUserEmail.focus()
        },
        methods: {
            $_admin_user_add_clearInput () {
                this.loading = false
                this.email = ''
                this.password = ''
                this.confirmPassword = ''
                this.phone = ''
                this.type = ''
                this.companyName = ''
                this.status = 'unconfirmed'
                this.wantMessage = false
            },
            $_admin_user_add_checkAddUser () {
                const {email, password, phone, type, companyName, status, wantMessage} = this
                this.$_admin_user_add_toggleLoading()
                const headers = {'authorization': this.$store.state.token}
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiUser
                /* eslint-disable object-property-newline */
                let body = {email, password, phone, type, status, wantMessage}
                if (companyName) {
                    body.companyName = companyName
                }
                api.request('post', path, body, {}, headers)
                    .then(response => {
                        const data = response.data
                        /* Checking if error object was returned from the server */
                        if (data.error) {
                            const errorName = data.error.name
                            if (errorName) {
                                this.response = errorName
                            } else {
                                this.response = data.error
                            }

                            return
                        }
                        /* Setting user in the state and caching record to the localStorage */
                        if (response.data.status.code === 0) {
                            this.insertSuccess = true
                            console.log('in ???')
                            setTimeout(function () { this.$router.push({name: 'listUser'}) }.bind(this), 1000)
                        }
                    })
                    .catch(error => {
                        this.$store.commit('TOGGLE_LOADING')
                        console.log(error)

                        this.response = 'Server appears to be offline'
                        this.$_admin_user_add_toggleLoading()
                    })
            },
            $_admin_user_add_toggleLoading () {
                this.loading = !this.loading
            },
            $_admin_user_add_closeAndRedirect () {
                this.$router.push({name: 'listUser'})
            }
        }
    }
</script>

<style scoped>
    .datetime-picker input {
        height: 4em !important;
    }

    .trash {
        position: relative;
        transform: translateY(70%);
    }
</style>



// WEBPACK FOOTER //
// AddUser.vue?59359753